import BudgetNew from "../Components/BudgetNew";

function New() {
    return (
        <BudgetNew />
    );
}

export default New;